import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
  noMatch: {
    display: "flex",
    alignItems: "center",
    textAlign: "center",
    color: "var(--text-primary, rgba(0, 0, 0, 0.87))",
    fontSize: "inherit",
    "& svg": {
      width: "20px",
      height: "20px",
      marginRight: "8px",
    },
  },
  notAvailable: {
    color: "var(--text-secondary, rgba(0, 0, 0, 0.60))",
    display: "flex",
    gap: "8px",
    fontSize: "inherit",
    "& svg": {
      width: "20px",
      height: "20px",
    },
  },
}));
 